import { useState, useEffect } from "react";
import type { AuthenticatedUser } from "../../api/auth";
import { fetchSession } from "../../api/auth";
import type { LaunchpadTile } from "../../components/Launchpad";
import { UserManagementPage } from "../../components/UserManagement/UserManagementPage";
import { TenantContainer } from "../TenantContainer";

// Default tiles for IntecIO tenant (fallback if API returns no tiles)
const DEFAULT_TILES: LaunchpadTile[] = [
    {
        id: "users",
        title: "Benutzerverwaltung",
        description: "Verwalten Sie Benutzer und Berechtigungen",
        path: "/users"
    }
];

const TENANT_ROUTES = [
    { path: "/users", element: <UserManagementPage /> }
];

interface TenantRootProps {
    currentUser?: AuthenticatedUser;
}

export function TenantRoot({ currentUser: propCurrentUser }: TenantRootProps) {
    const [currentUser, setCurrentUser] = useState<AuthenticatedUser | undefined>(propCurrentUser);

    useEffect(() => {
        if (!currentUser) {
            fetchSession().then(session => {
                if (session.authenticated && session.user) {
                    setCurrentUser(session.user);
                }
            });
        }
    }, [currentUser]);

    return (
        <TenantContainer
            tiles={DEFAULT_TILES}
            routes={TENANT_ROUTES}
            currentUser={currentUser}
        />
    );
}
